class StickyBuyBar extends HTMLElement {
  connectedCallback() {
    const watchId = this.dataset.watch;
    const target = watchId && document.getElementById(watchId);
    if (!target || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }
}

customElements.define('sticky-buy-bar', StickyBuyBar);
